const passengers = {
  table: {
    headers: {
      createBtn: 'Create',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      baseAddress: 'Home Address',
      alternateAddress: 'Alternate Address',
      occupationAddress: 'School',
      createdAt: 'Created At',
      profile: 'Profile',
    },
  },
};

export default passengers;
